import { render } from "./CompareIcon.vue?vue&type=template&id=5d653175"
import script from "./CompareIcon.vue?vue&type=script&lang=js"
export * from "./CompareIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__